export class CheckPetSexSpecieModel {
    intCodeNo: number
    intCodeType: number
    lngPetNo: number
    INVENT: number
    intClinicNo: number
    message: string
    check: number

    constructor(
        intCodeNo: number,
        intCodeType: number,
        lngPetNo: number,
        INVENT: number,
        intClinicNo: number,
        message: string,
        check: number
    ) {
        this.intCodeNo = intCodeNo
        this.intCodeType = intCodeType
        this.lngPetNo = lngPetNo
        this.INVENT = INVENT
        this.intClinicNo = intClinicNo
        this.message = message
        this.check = check
    }
}